import HelixConnectivityActiveIcon from '@/comp/common/icons/HelixConnectivityActiveIcon';
import HelixConnectivityNotActiveIcon from '@/comp/common/icons/HelixConnectivityNotActiveIcon';
import HelixConnectivityNotCompatibleIcon from '@/comp/common/icons/HelixConnectivityNotCompatibleIcon';
import HelixConnectivityNullIcon from '@/comp/common/icons/HelixConnectivityNullIcon';
import HelixConnectivityDisconnectedIcon from '@/comp/common/icons/HelixConnectivityDisconnectedIcon';

export enum HelixConnectivityEnum {
  Active = 'Active',
  DisconnectedActive = 'disconnectedActive',
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Null = 'Null',
  EnabledNotActive = 'Enabled - Not Active',
  Compatible = 'Compatible',
  NotCompatible = 'Not Compatible',
  OptedOut = 'Opted Out',
  NoState = 'NoState',
  DisconnectedDisconnected = 'disconnectedDisconnected',
}

export const HelixDetailsMappingByConnectivityStatus = {
  [HelixConnectivityEnum.Active]: {
    icon: <HelixConnectivityActiveIcon />,
    tooltipText: 'active',
  },
  [HelixConnectivityEnum.Connected]: {
    icon: <HelixConnectivityActiveIcon />,
    tooltipText: 'Connected',
  },
  [HelixConnectivityEnum.EnabledNotActive]: {
    icon: <HelixConnectivityNotActiveIcon />,
    tooltipText: 'notActive',
  },
  [HelixConnectivityEnum.Compatible]: {
    icon: <HelixConnectivityActiveIcon isCompatible />,
    tooltipText: 'compatible',
  },
  [HelixConnectivityEnum.NotCompatible]: {
    icon: <HelixConnectivityNotCompatibleIcon />,
    tooltipText: 'notCompatible',
  },
  [HelixConnectivityEnum.OptedOut]: {
    icon: <HelixConnectivityNotActiveIcon isOptedOut />,
    tooltipText: 'optOut',
  },
  [HelixConnectivityEnum.Null]: {
    icon: <HelixConnectivityNullIcon />,
    tooltipText: 'Unknown',
  },
  [HelixConnectivityEnum.DisconnectedActive]: {
    icon: <HelixConnectivityDisconnectedIcon />,
    tooltipText: 'Disconnected',
  },
  [HelixConnectivityEnum.Disconnected]: {
    icon: <HelixConnectivityDisconnectedIcon />,
    tooltipText: 'Disconnected',
  },
  [HelixConnectivityEnum.DisconnectedDisconnected]: {
    icon: <HelixConnectivityNotActiveIcon />,
    tooltipText: 'optOut',
  },
};
